import React, { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Menu, Sidebar } from 'semantic-ui-react';
import { pivotData } from '../../../features/PivotReports/PivotStore';
import RegisterForm from '../../../features/Users/RegisterForm';
import { useStore } from '../../stores/store';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import '../MediaQuery/responsive-sidebar.css';
import agent from '../../api/agent';
import { toast } from 'react-toastify';
import SmartFlowList from './smartFlowList';
import SmartFlowListForNFAIRestoration from './smartFlowList/SmartFlowListForNFAIRestoration';

const DeleteModal = React.lazy(() => import('../../../library/deleteModal'));

export default observer(function SidebarContainer() {
  const {
    modalStore,
    sidebarStore,
    dashboardStore,
    userStore: { user },
    PivotStore,
    commonStore,
    WorkLevelStore,
    reportStore,
    userStore,
  } = useStore();
  const { ismasterTitlechanger } = reportStore;
  const [hoverEnable, setHoverEnable] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState({
    id: '',
    type: '',
  });

  // const [pivotSaveAsReport,setPivotSaveAsReport]=useState()
  // setting the sidebar automated close
  const history = useNavigate();

  useEffect(() => {
    sidebarStore.sidebar.open = false;

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sidebarStore.sidebar.open) {
      if (
        userStore.user?.customerName !== 'NFAI' ||
        window.innerWidth > 1025 ||
        window.innerWidth < 1020
      ) {
        sidebarStore.getSidebarFormList();
      }
    }

    // eslint-disable-next-line
  }, [sidebarStore.sidebar.open]);

  useEffect(() => {
    if (
      userStore.user?.customerName !== 'NFAI' ||
      window.innerWidth > 1025 ||
      window.innerWidth < 1020
    ) {
      PivotStore.getSavedAsPivot(user?.customerName!);
      PivotStore.getExistingPinnedIDs(user?.id!);
    }
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    if (
      userStore.user?.customerName !== 'NFAI' ||
      window.innerWidth > 1025 ||
      window.innerWidth < 1020
    ) {
      WorkLevelStore.loadAllMasters();
    }
    // eslint-disable-next-line
  }, [user, WorkLevelStore.reloadMastersCall]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      sidebarStore.closeSidebar();
    }
    // eslint-disable-next-line
  }, [window.innerWidth]);

  const closeSiderInMob = () => {
    if (window.innerWidth < 768) {
      sidebarStore.closeSidebar();
    }
  };

  const routeChange = (path: string, title?: string) => {
    history(path, {
      state: { state: title },
    });
  };

  const pinColorFunc = (id: string) => {
    if (PivotStore.pinnedIDForUser?.pinnedAssets?.includes(id)) {
      return 'pinned-icon-data-enable';
    } else {
      return 'pinned-icon-data-disable';
    }
  };

  const masterTableDeleteHandler = async () => {
    await agent.dynamicMaster.deleteMasterReport({
      masterId: deleteDetails.id,
    });
    let filter = sidebarStore.masterFormList?.filter(
      (d) => d.masterId !== deleteDetails.id,
    );
    sidebarStore.masterFormList = filter;

    toast.success('Table Deleted Successfully');
    setIsModalOpen(false);
  };
  return (
    <Sidebar
      className={
        userStore.user?.customerName === 'Isha Foundation'
          ? 'ishaSidebarContainer'
          : 'sidebarContainer'
      }
      animation="overlay"
      direction="left"
      icon="labeled"
      // onHide={sidebarStore.closeSidebar}
      visible={sidebarStore.sidebar.open}
      width="wide"
      onMouseEnter={sidebarStore.openSidebar}
      onMouseOver={sidebarStore.openSidebar}
      onMouseOut={sidebarStore.closeSidebar}
      onClick={closeSiderInMob}
    >
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
              setDeleteDetails({
                id: '',
                type: '',
              });
            }}
            deleteHandler={masterTableDeleteHandler}
            header={'Delete'}
            text={'Are you sure you want to delete this?'}
          />
        </Suspense>
      )}

      <div className="large-screen-sidebar">
        <Menu
          vertical
          fluid
          size="large"
          style={{ marginTop: '4.6em', bottom: '0' }}
        >
          {commonStore.filterModeTwo?.includes('DB02') ? (
            <></>
          ) : (
            <>
            { (userStore.user?.customerName === "Mepz" || userStore.user?.customerName === "TNCA") &&
            <Menu.Item onClick={() => routeChange('/mepzDashboard')}>
            Dashboard
            <Icon name="dashboard"/>
            </Menu.Item>
            }
            <Menu.Item
              exact="true"
              disabled={commonStore.filterModeZero?.includes('DB02')}
              onClick={() => {userStore.user?.customerName === "Mepz" || userStore.user?.customerName === "TNCA"  ? routeChange('/dashboard'): routeChange('/')}}
            >
              <Icon
                name="home"
                //Home
              />
              {
                (userLanguage[0].Sidebar?.M01 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
            </Menu.Item>
            </>
          )}
          {(([
            'Resto Admin',
            'Basic User',
            'Operator',
            'Process Lead',
            'ProcessLead',
            'Process Specialist',
            'Production Co-ordinator',
            'Quality Check',
            'Restoration Admin',
            'QC',
            'Colorization',
          ].includes(userStore.user?.roleName as string) &&
            userStore.user?.customerName === 'Restoration') ||
            ['LVP CMS - SOB', 'Mumbai', 'Area 51', 'Isha Foundation'].includes(
              userStore?.user?.customerName as string,
            ) ||
            userStore.user?.customerName === 'Museum'  ||
            userStore.user?.customerName === 'LVP CMS - AM' ||
            // eslint-disable-next-line
            (userStore.user?.customerName === 'PCPLCRM'  && userStore?.user?.roleName?.trim() !== 'IT Team') ||
            // eslint-disable-next-line
            ['Quality Check','Operator'].includes(userStore.user?.roleName as string) &&
            userStore.user?.customerName === 'NFAIReport') && (
            <Menu.Item
              exact="true"
              disabled={commonStore.filterModeZero?.includes('DB02')}
              onClick={() => routeChange('/dashboard')}
            >
              <Icon
                name="dashboard"
                //Home
              />
              {'Dashboard'}
            </Menu.Item>
          )}

          {user?.customerName !== 'Paramount Global' ? (
            <>
              {commonStore.filterModeTwo?.includes('KAN01') ? (
                <></>
              ) : (
                <Menu.Item
                  className={
                    commonStore.filterModeZero?.includes('KAN01')
                      ? 'component-isDisabled'
                      : ''
                  }
                  onClick={() => routeChange('/Kanban')}
                  //Board
                >
                  {
                    (userLanguage[0].Sidebar?.M02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
            </>
          ) : null}
          {commonStore.filterModeTwo?.includes(
            'a69e4760-5da1-4009-9098-e20fda89e7d8',
          ) ? (
            <></>
          ) : (
            !['Mumbai', 'LVP CMS - SOB', 'LVP CMS - AM', 'Area 51'].includes(
              userStore.user?.customerName as string,
            ) && (
              <Menu.Item
                disabled={commonStore.filterModeZero?.includes(
                  'a69e4760-5da1-4009-9098-e20fda89e7d8',
                )}
                onClick={() => routeChange('/dynamic_dashboard')}
                // dynamic_dashboard
              >
                {
                  (userLanguage[0].Sidebar?.M02I01 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
            )
          )}
           {
            (userStore.user?.customerName === "Mepz" ||
            userStore.user?.customerName === "BroekmanLogistics" || userStore.user?.customerName === "TNCA" ) && (
              <>
                <Menu.Item onClick={() => routeChange('/Scan')}>
                  Scan
                </Menu.Item>
                <Menu.Item onClick={() => routeChange('/DataSync')}>
                  Data Sync
                </Menu.Item>
              </>
            )}
          {commonStore.filterModeTwo?.includes('SMF01') ? (
            <></>
          ) : (
            commonStore.NFAIReportCustomer ? <SmartFlowListForNFAIRestoration /> : <SmartFlowList />
          )}

          {(user?.customerName === 'Paramount Global' ||
            user?.customerName === 'CeeW' ||
            user?.customerName === 'PC Technology') && (
            <Menu.Item
              name="Elastic Search"
              onClick={() => routeChange('/search')}
              style={{ color: '#616161' }}
              //Elastic Search
            >
              Elastic Search
            </Menu.Item>
          )}

          {!commonStore.filterModeTwo.includes('VMRVB1') && (
            // VMRVB1
            <Menu.Item name="Vault Master">
              <Icon
                name="archive"
                //Vault Master
              />
              {user?.customerName === 'LVP CMS - AM'
                ? 'Room Master'
                : (userLanguage[0].Sidebar?.M03 as any)?.[
                    `${commonStore.language.key}`
                  ]}
              <Menu.Menu>
                <Menu.Item
                  name=" Register Vault"
                  // disabled={
                  //   dashboardStore.dashboard.selectedUserRoleId.includes(
                  //     'VMRVB1',
                  //   )
                  //     ? false
                  //     : true
                  // }
                  onClick={() => {
                    user?.customerName === 'LVP CMS - AM'
                      ? routeChange('/registerRoom')
                      : routeChange('/registerVault');
                  }}
                  style={{ color: '#616161' }}
                  //Register Vault
                >
                  {user?.customerName === 'LVP CMS - AM'
                    ? 'Register Room'
                    : (userLanguage[0].Sidebar?.M03I01 as any)?.[
                        `${commonStore.language.key}`
                      ]}
                </Menu.Item>
                <Menu.Item
                  name="View Vault"
                  onClick={() =>
                    user?.customerName === 'LVP CMS - AM'
                      ? routeChange('/viewRoom')
                      : routeChange('/viewVault')
                  }
                  // disabled={
                  //   dashboardStore.dashboard.selectedUserRoleId.includes(
                  //     'VMVVB01',
                  //   )
                  //     ? false
                  //     : true
                  // }
                  style={{ color: '#616161' }}
                  //View Vault
                >
                  {user?.customerName === 'LVP CMS - AM'
                    ? 'View Room'
                    : (userLanguage[0].Sidebar?.M03I02 as any)?.[
                        `${commonStore.language.key}`
                      ]}
                </Menu.Item>
              </Menu.Menu>
            </Menu.Item>
          )}
          {!commonStore.filterModeTwo.includes('DMRDB01') &&
            user?.customerName !== 'Paramount Global' && (
              <Menu.Item name="Device Master">
                <Icon
                  name="hdd"
                  //Device Master
                />
                {
                  (userLanguage[0].Sidebar?.M04 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
                <Menu.Menu>
                  <Menu.Item
                    name=" Register Device"
                    // disabled={
                    //   dashboardStore.dashboard.selectedUserRoleId.includes(
                    //     'DMRDB01',
                    //   )
                    //     ? false
                    //     : true
                    // }
                    onClick={() => routeChange('/registerDevice')}
                    style={{ color: '#616161' }}
                    //Register Device
                  >
                    {
                      (userLanguage[0].Sidebar?.M04I01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Menu.Item>

                  <Menu.Item
                    name="View Device"
                    // disabled={
                    //   dashboardStore.dashboard.selectedUserRoleId.includes(
                    //     'DMVDB01',
                    //   )
                    //     ? false
                    //     : true
                    // }
                    onClick={() => routeChange('/viewdevice')}
                    style={{ color: '#616161' }}
                    //View Device
                  >
                    {
                      (userLanguage[0].Sidebar?.M04I02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Menu.Item>
                </Menu.Menu>
              </Menu.Item>
            )}
          {(user?.departmentName === 'Colorization') && (user?.roleName === 'Restoration Admin' || user?.roleName === 'Process Lead' || user?.roleName === 'ProcessLead') && (
              <Menu.Item
                // style={{ color: '#616161' }}
                onClick={()=>{routeChange(`/multipleDeleteOptionForTasks`)}}
              > <Icon name = 'delete calendar'/>
                  Multi-Cutlist Delete
              </Menu.Item>
          )}

          {!commonStore.filterModeTwo.includes('SRMRB01') && (
            <Menu.Item name="Shelf/Rack Master">
              <Icon
                name="server"
                //Shelf/Rack Master
              />
              {
                commonStore.hfcCustomerChanges? "Room/Shelf Master":
                (userLanguage[0].Sidebar?.M05 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              <Menu.Menu>
                <Menu.Item
                  name=" Register Rack"
                  // disabled={
                  //   dashboardStore.dashboard.selectedUserRoleId.includes(
                  //     'SRMRB01',
                  //   )
                  //     ? false
                  //     : true
                  // }
                  onClick={() => routeChange('/registerShelfRack')}
                  style={{ color: '#616161' }}
                  //Register Shelf/Rack
                >
                  { commonStore.hfcCustomerChanges ? "Register Room/Shelf" :
                    (userLanguage[0].Sidebar?.M05I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
                <Menu.Item
                  name="View Rack"
                  // disabled={
                  //   dashboardStore.dashboard.selectedUserRoleId.includes(
                  //     'SRMVB01',
                  //   )
                  //     ? false
                  //     : true
                  // }
                  onClick={() => routeChange('/viewShelfRack')}
                  style={{ color: '#616161' }}
                  //View Shelf/Rack
                >
                  {
                    commonStore.hfcCustomerChanges ? "View Room/Shelf" :
                    (userLanguage[0].Sidebar?.M05I02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              </Menu.Menu>
            </Menu.Item>
          )}
          {user?.customerName !== 'NFAIReport' && <Menu.Item name="Department Master">
            <Icon
              name="sitemap"
              //Department Master
            />
            {
              (userLanguage[0].Sidebar?.M06 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            <Menu.Menu>
              {!commonStore.filterModeTwo.includes('DMRB01') && (
                <Menu.Item
                  name=" Register Department"
                  disabled={commonStore.filterModeZero?.includes('DMRB01')}
                  onClick={() => routeChange('/registerDepartment')}
                  style={{ color: '#616161' }}
                  //Register Department
                >
                  {
                    (userLanguage[0].Sidebar?.M06I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {!commonStore.filterModeTwo.includes('DMVB01') && (
                <Menu.Item
                  name="View Department"
                  disabled={commonStore.filterModeZero?.includes('DMVB01')}
                  onClick={() => routeChange('/viewDepartment')}
                  style={{ color: '#616161' }}
                  //View Department
                >
                  {
                    (userLanguage[0].Sidebar?.M06I02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
            </Menu.Menu>
          </Menu.Item>}
          {user?.isAdmin === false ? null : (
            <Menu.Item name="Customer Master">
              <Icon
                name="users"
                //Customer Master
              />
              {
                (userLanguage[0].Sidebar?.M07 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              <Menu.Menu>
                <Menu.Item
                  name=" Register Customer"
                  disabled={
                    dashboardStore.dashboard.selectedUserRoleId.includes(
                      'CMRB01',
                    )
                      ? false
                      : true
                  }
                  onClick={() => routeChange('/registerCustomer')}
                  style={{ color: '#616161' }}
                  //Register Customer
                >
                  {
                    (userLanguage[0].Sidebar?.M07I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>

                <Menu.Item
                  name="View Customer"
                  disabled={
                    dashboardStore.dashboard.selectedUserRoleId.includes(
                      'CMVB01',
                    )
                      ? false
                      : true
                  }
                  onClick={() => routeChange('/viewCustomer')}
                  style={{ color: '#616161' }}
                  //View Customer
                >
                  {
                    (userLanguage[0].Sidebar?.M07I02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              </Menu.Menu>
            </Menu.Item>
          )}

          {user?.customerName !== 'Paramount Global' ? (
            commonStore.filterModeTwo?.includes('ALLU01') ? (
              <></>
            ) : (
              <Menu.Item
                name="Allocate User"
                disabled={commonStore.filterModeZero?.includes('ALLU01')}
                onClick={() => routeChange('/allocateuser')}
                style={{ color: '#616161' }}
                //Allocate User
              >
                {
                  (userLanguage[0].Sidebar?.M09 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
            )
          ) : null}

          {(user?.customerName === 'NFAIReport') &&(
            <Menu.Item
              name="Audio Work TimeSheet"
              onClick={()=> routeChange('/NFAIProcess')}
            >
              NFAI Work TimeSheet
            </Menu.Item>
          )}
          {
            user?.displayName === 'Mohamed Ehagaya' || user?.displayName === 'E1709' || user?.displayName === "R3077" || user?.displayName === "R4456" ? (
              <Menu.Item
              name="Mastering Dashboard"
              onClick={()=> routeChange('/MasteringDashboard')}
            >
              Mastering Dashboard
            </Menu.Item>
            ) : null
          }

          {user?.customerName !== 'Paramount Global' ? (
            commonStore.filterModeTwo?.includes('AVIB02') ? (
              <></>
            ) : (
              <Menu.Item
                name="Quick Scan"
                disabled={commonStore.filterModeZero?.includes('AVIB02')}
                onClick={() => routeChange('/quickScan')}
                style={{ color: '#616161' }}
                //Quick Scan
                //{(userLanguage[0].Sidebar?.M09 as any)?.[`${commonStore.language.key}`]+"Quick Scan"}
              >
                {
                  (userLanguage[0].Sidebar?.M16 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
            )
          ) : null}
          {commonStore.filterModeTwo?.includes('RMDB01') ? (
            <></>
          ) : (
            <Menu.Item name="Assets">
              <Icon
                name="film"
                //Assets
              />
              {
                (userLanguage[0].Sidebar?.M08 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              <Menu.Menu>
                {commonStore.filterModeTwo?.includes('AWLB01') ? (
                  <></>
                ) : (
                  <Menu.Item
                    name="Work Level Master"
                    disabled={commonStore.filterModeZero?.includes('AWLB01')}
                    onClick={() => routeChange('/registerWorkLevelMaster')}
                    style={{ color: '#616161' }}
                    //Register Item Group
                  >
                    {
                      (userLanguage[0].Sidebar?.M08I01 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Menu.Item>
                )}
                {commonStore.filterModeTwo?.includes('AVIB01') ? (
                  <></>
                ) : (
                  <Menu.Item
                    name="View Work Level Master"
                    disabled={commonStore.filterModeZero?.includes('AVIB01')}
                    onClick={() => routeChange('/viewWorkLevelMaster')}
                    style={{ color: '#616161' }}
                    //View Item Group
                  >
                    {
                      (userLanguage[0].Sidebar?.M08I02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Menu.Item>
                )}
                {commonStore.filterModeTwo?.includes('AILB01') ||
                userStore.user?.customerName === 'Isha Foundation' ? (
                  <></>
                ) : (
                  <Menu.Item
                    name="View Assets"
                    disabled={commonStore.filterModeZero?.includes('AILB01')}
                    onClick={() => routeChange('/mediaAssets')}
                    style={{ color: '#616161' }}
                    //View Item Level
                  >
                    {
                      (userLanguage[0].Sidebar?.M08I03 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Menu.Item>
                )}
              </Menu.Menu>
            </Menu.Item>
          )}

          {user?.customerName !== 'Paramount Global' ? (
            <>
              {commonStore.filterModeTwo?.includes('AVIB07') ? (
                <></>
              ) : (
                <Menu.Item
                  name="Create Master"
                  disabled={commonStore.filterModeZero.includes('AVIB07')}
                  onClick={() => routeChange('/createMaster')}
                  style={{ color: '#616161' }}
                  //Create Master
                >
                  {
                    (userLanguage[0].Sidebar?.M14 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
            </>
          ) : null}
          {!!sidebarStore.masterFormList?.length &&
            sidebarStore.masterFormList?.map(
              ({ masterId, title, icon }: any) => {
                return (
                  !commonStore.filterModeTwo.includes(masterId) && (
                    <Menu.Item name="Dynamic Report" key={masterId}>
                      {user?.roleName === 'Admin' && (
                        <Icon
                          name="trash"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setIsModalOpen(true);
                            setDeleteDetails({
                              id: masterId,
                              type: '',
                            });
                          }}
                        />
                      )}
                      {icon && <Icon name={icon} />}
                      {title}
                      <Menu.Menu
                        disabled={commonStore.filterModeZero.includes(masterId)}
                      >
                        <Menu.Item
                          disabled={commonStore.filterModeZero.includes(
                            masterId,
                          )}
                          name={title}
                          style={{ color: '#616161' }}
                          onClick={() =>
                            routeChange(`/newMasterForm/${masterId}`, title)
                          }
                        >
                          Register {title}
                        </Menu.Item>
                        <Menu.Item
                          disabled={commonStore.filterModeZero.includes(
                            masterId,
                          )}
                          name={title}
                          style={{ color: '#616161' }}
                          onClick={() => {
                            routeChange(`/newMasterReport/${masterId}`);
                            ismasterTitlechanger(title);
                          }}
                        >
                          {title} Reports
                        </Menu.Item>
                      </Menu.Menu>
                    </Menu.Item>
                  )
                );
              },
            )}

          <Menu.Item name="Reports">
            {' '}
            <Icon
              name="list"
              //Reports
            />{' '}
            {
              (userLanguage[0].Sidebar?.M10 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            <Menu.Menu>
              {' '}
              {commonStore.filterModeTwo?.includes('RMDB01') ? (
                <></>
              ) : (
                <Menu.Item
                  name="Reports Table"
                  disabled={commonStore.filterModeZero?.includes('RMDB01')}
                  onClick={() => routeChange('/reports')}
                  style={{ color: '#616161' }}
                  //Meta Data Report
                >
                  {' '}
                  {
                    (userLanguage[0].Sidebar?.M10I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {commonStore.filterModeTwo?.includes('RPTB01') ? (
                <></>
              ) : (
                <Menu.Item
                  name="Pivot Table"
                  disabled={commonStore.filterModeZero?.includes('RPTB01')}
                  onClick={() => routeChange('/pivottable')}
                  style={{ color: '#616161' }}
                  //Pivot Table
                >
                  {' '}
                  {
                    (userLanguage[0].Sidebar?.M10I02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {commonStore.filterModeTwo?.includes('FARR01') ? (
                <></>
              ) : (
                (user?.customerName === 'NFAI') && (
                  <Menu.Item
                    name="Pivot Table"
                    disabled={commonStore.filterModeZero?.includes('FARR01')}
                    onClick={() => routeChange('/FilmAnalysis_RepairReport')}
                    style={{ color: '#616161' }}
                    //  Film Analysis & Repair Report
                  >
                    Film Analysis And Repair Report
                  </Menu.Item>
                )
              )}
              {commonStore.filterModeTwo?.includes('PCPCSV01') ? (
                <></>
              ) : (
                (user?.customerName === 'NFAI') && (
                  <Menu.Item
                    name="Pivot Table"
                    disabled={commonStore.filterModeZero?.includes('PCPCSV01')}
                    onClick={() => routeChange('/PC_Process_CsvReport')}
                    style={{ color: '#616161' }}
                    //  Film Analysis & Repair Report
                  >
                    PC Process CsvReport
                  </Menu.Item>
                )
              )}
              {commonStore.filterModeTwo?.includes('RSP01') ? (
                <></>
              ) : (
                <span
                  className={
                    commonStore.filterModeZero?.includes('RSP01')
                      ? 'component-isDisabled'
                      : ''
                  }
                >
                  {/* {commonStore.filterModeTwo?.includes('RSQCT01') ? (
                    <></>
                  )
                   : (
                    (user?.customerName === 'EFX-RES' ||
                      user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="Restoration Qc Summary"
                        disabled={commonStore.filterModeZero?.includes(
                          'RSQCT01',
                        )}
                        // disabled={ dashboardStore.dashboard.selectedUserRoleId.includes("RMDB01") ? false : true }       demo some role create
                        onClick={() => routeChange('/qcTable')}
                        style={{ color: '#616161' }}
                        //Restoration Qc Summary
                      >
                        {' '}
                        Restoration Qc Summary
                      </Menu.Item>
                    )
                  )
                  } */}
                  {commonStore.filterModeTwo?.includes('RSTSR01') ? (
                    <></>
                  ) : (
                    (user?.customerName === 'EFX-RES' ||
                      (user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization')) ? (
                      <Menu.Item
                        name="Title-wise Summary Report"
                        disabled={commonStore.filterModeZero.includes(
                          'RSTSR01',
                        )}
                        onClick={() => routeChange('/TitleSummaryReport')}
                        style={{ color: '#616161' }}
                        //Title-wise Summary Report
                      >
                        {' '}
                        Title-wise Summary Report
                      </Menu.Item>
                    ) :null
                  )}
                  {commonStore.filterModeTwo?.includes('RSQRH01') ? (
                    <></>
                  ) : (
                    (user?.customerName === 'EFX-RES' ||
                      user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="Defect Report"
                        disabled={commonStore.filterModeZero.includes(
                          'RSQRH01',
                        )}
                        onClick={() => routeChange('/defectReport')}
                        style={{ color: '#616161' }}
                        //Defect Report
                      >
                        Defect Report
                      </Menu.Item>
                    )
                  )}
                 {(commonStore.NFAIReportCustomer && user?.roleName !== "Operator") && (
                    <Menu.Item
                      name='Culist All Complete Report'
                      onClick={() => routeChange('/CulistAllCompleteReport')}
                      style={{ color: '#616161'}}
                    >
                      Culist All Complete Report
                    </Menu.Item>
                  )}
                  {(user?.displayName === "Mohamed Ehagaya" || user?.displayName === "R1498" || user?.displayName === "R3077") && (
                    <Menu.Item
                      name='NFAI Defect Report'
                      onClick={() => routeChange('NFAIDefectReport')}
                      style={{ color: '#616161'}}
                    >
                      NFAI Defect Report
                    </Menu.Item>
                  )}
                  {commonStore.filterModeTwo?.includes('RSRSR01') ? (
                    <></>
                  ) : (
                    (user?.customerName === 'EFX-RES' ||
                      user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="Reel-wise Summary Report"
                        disabled={commonStore.filterModeZero.includes(
                          'RSRSR01',
                        )}
                        onClick={() => routeChange('/ReelSummaryReport')}
                        style={{ color: '#616161' }}
                        //Reel-wise Summary Report
                      >
                        {' '}
                        Reel-wise Summary Report
                      </Menu.Item>
                    )
                  )}
                  {commonStore.filterModeTwo?.includes('RSPLSR01') ? (
                    <></>
                  ) : (
                    (user?.customerName === 'EFX-RES' ||
                      user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="PL-wise Summary Report"
                        disabled={commonStore.filterModeZero.includes(
                          'RSPLSR01',
                        )}
                        onClick={() => routeChange('/PLSummaryReport')}
                        style={{ color: '#616161' }}
                        //PL-wise Summary Report
                      >
                        {' '}
                        Lead Status Summary by Title
                      </Menu.Item>
                    )
                  )}
                  {commonStore.filterModeTwo?.includes('RSOP01') ? (
                    <></>
                  ) : (
                    (user?.customerName === 'EFX-RES' ||
                      (user?.customerName === 'Restoration' && user?.departmentName !== "Colorization")) ? (
                      <Menu.Item
                        name="Operator Performance"
                        disabled={commonStore.filterModeZero.includes('RSOP01')}
                        onClick={() => routeChange('/operatorPerformance')}
                        style={{ color: '#616161' }}
                        //Operator Performance Report
                      >Operator Performance Report
                      </Menu.Item>
                    ):(
                      (user?.customerName === 'Restoration' && user?.departmentName === "Colorization") && (
                      <Menu.Item
                        name="Performance Report"
                        disabled={commonStore.filterModeZero.includes('RSOP01')}
                        onClick={() => routeChange('/operatorPerformanceColorization')}
                        style={{ color: '#616161' }}
                        //Operator Performance Report
                      >Performance Report
                      </Menu.Item>
                    ))
                  )}
                  {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration') && (
                    <Menu.Item
                      name="Colorization Monthly Productivity Report"
                      onClick={() => routeChange('/ColorizationMonthlyProductivityReport')}
                      style={{ color: '#616161' }}
                    >
                      Colorization Productivity Report
                    </Menu.Item>
                  )}
                  {(user?.customerName === 'PCPLCRM') && (
                    <Menu.Item
                     name='CRM Asset Tracking'
                     onClick={()=> routeChange('/crmAssetTracking')}
                    >
                      CRM Asset Tracking
                    </Menu.Item>
                  )}
                  {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration' ||
                    commonStore.NFAIReportCustomer) && (
                    <Menu.Item
                      name="Cutlist Status Report"
                      onClick={() => routeChange('/Cutliststatusreport')}
                      style={{ color: '#616161' }}
                    >
                      Cutlist Status Report
                    </Menu.Item>
                  )}
                    {commonStore.NFAIReportCustomer && (
                    <Menu.Item
                      name="Operator Performance"
                      onClick={() => routeChange('/operatorPerformanceNFAI')}
                      style={{ color: '#616161' }}
                    >
                      Operator Performance Report
                    </Menu.Item>
                  )}

                  {(["R3077", "R1498", "E1709", "R4297", "R1187", "R4264", "R1509"].includes(user?.displayName as string)) && (
                    <Menu.Item
                      name="Operator Performance"
                      onClick={() => routeChange('/QualityCheckPerformanceReport')}
                      style={{ color: '#616161' }}
                    >
                      Quality Check Performance Report
                    </Menu.Item>
                  )}

                  {(user?.customerName === 'EFX-RES' ||
                   (user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization')) ? (
                    <Menu.Item
                      name="Quality Team Titlewise Performance"
                      disabled={commonStore.filterModeZero.includes('QTTP01')}
                      onClick={() =>
                        routeChange('/QualityTeamTitlewisePerformace')
                      }
                      style={{ color: '#616161' }}
                    >
                      Quality Team Titlewise Performance
                    </Menu.Item>
                  ):null}
                   {(user?.customerName === 'EFX-RES' ||
                    (user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization')) ?
                    (commonStore.filterModeOne.includes('TWPHR01')) &&  (
                    <Menu.Item
                    name="Title-wise Production Hours Report"
                      disabled={commonStore.filterModeZero.includes('TWPHR01')}
                      onClick={() =>
                        routeChange('/TitleWiseProductionHoursReport')
                      }
                      style={{ color: '#616161' }}
                    >
                     Title-wise Production Hours Report
                    </Menu.Item>
                  ):null}
                   {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration') &&
                    (commonStore.filterModeOne.includes('EDP01')) && (
                    <Menu.Item
                      name="Employee Details Report"
                      disabled={commonStore.filterModeZero.includes('EDP01')}
                      onClick={() =>
                        routeChange('/EmployeeDetailsReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      Employee Details Report
                    </Menu.Item>
                  )}
                    {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration')  &&
                    (commonStore.filterModeOne.includes('PHR01')) && (
                    <Menu.Item
                      name="MIS Production & Quality Report"
                      disabled={commonStore.filterModeZero.includes('PHR01')}
                      onClick={() =>
                        routeChange('/MISProductionAndQualityReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      MIS Production & Quality Report
                    </Menu.Item>
                  )}
                    {(user?.customerName === 'EFX-RES' ||
                    (user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization'))  ?
                    (commonStore.filterModeOne.includes('CWR01')) && (
                    <Menu.Item
                      name="Cluster  Report"
                      disabled={commonStore.filterModeZero.includes('CWR01')}
                      onClick={() =>
                        routeChange('/ClusterReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      Cluster Report
                    </Menu.Item>
                  ):null}
                  {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration')  &&
                    (commonStore.filterModeOne.includes('TDR01')) && (
                    <Menu.Item
                      name="Title Dashboard Report"
                      disabled={commonStore.filterModeZero.includes('TDR01')}
                      onClick={() =>
                        routeChange('/TitleDashboardReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      Title Dashboard Report
                    </Menu.Item>
                  )}
                  {(user?.customerName === 'PCPLCRM' )  &&
                    (commonStore.filterModeOne.includes('TDR01')) && (
                    <Menu.Item
                      name="Title Dashboard Report"
                      disabled={commonStore.filterModeZero.includes('TDR01')}
                      onClick={() =>
                        routeChange('/TitleDashboardReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      Restoration Status Report
                    </Menu.Item>
                  )}
                 
                {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration')  &&
                    (commonStore.filterModeOne.includes('CCR01')) && (
                    <Menu.Item
                      name="Cluster Capacity Report"
                      disabled={commonStore.filterModeZero.includes('CCR01')}
                      onClick={() =>
                        routeChange('/ClusterCapacityReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      Cluster Capacity Report
                    </Menu.Item>
                  )}
                  {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration' || 
                    user?.customerName === 'NFAIReport') && 
                      (commonStore.filterModeOne.includes('HAR01') || user?.customerName === 'NFAIReport') && (
                        <Menu.Item
                          name="HoneyComb Attendance Hour"
                          disabled={commonStore.filterModeZero.includes('HAR01')}
                          onClick={() => routeChange('/DaywiseHoursAnalyzer')}
                          style={{ color: '#616161' }}
                        >
                          HoneyComb Attendance Hour 
                        </Menu.Item>
                    )
                  }
                {(user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="HoneyComb Attendance Hour"
                        disabled={commonStore.filterModeZero.includes('HAR01')}
                        onClick={() => routeChange('/HoursMissingEmployeeDetails')}
                        style={{ color: '#616161' }}
                      >
                        Hours Missing Employee Details
                      </Menu.Item>                
                )}
                {(user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="Title Productivity Report"
                        disabled={commonStore.filterModeZero.includes('HAR01')}
                        onClick={() => routeChange('/TitleProductivityReport')}
                        style={{ color: '#616161' }}
                      >
                        Title Productivity Report
                      </Menu.Item>                
                )}
                {(user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="Hour Delay Update Employee Details"
                        disabled={commonStore.filterModeZero.includes('HAR01')}
                        onClick={() => routeChange('/HCDelayUpdate')}
                        style={{ color: '#616161' }}
                      > Hour Delay Update Employee Details </Menu.Item>                
                )}
                {(user?.customerName === 'Restoration' &&
                  user?.roleName === 'Resto Admin') && (
                      <Menu.Item
                        name="Employee HC Hours Update"
                        disabled={commonStore.filterModeZero.includes('HAR01')}
                        onClick={() => routeChange('/ManualHoursAdd')}
                        style={{ color: '#616161' }}
                    >
                      Employee HC Hours Update
                    </Menu.Item>
                )}
                {(user?.customerName === 'Restoration') && (
                      <Menu.Item
                        name="Employee HC Hours Update"
                        disabled={commonStore.filterModeZero.includes('HAR01')}
                        onClick={() => routeChange('/MonthlyManualHoursAdd')}
                        style={{ color: '#616161' }}
                      > Employee HC Monthly Hours Update </Menu.Item>                
                )}
                {(user?.customerName === 'NFAIReport' &&
                  (user?.email === 'mohamedsabir.k@pcplgroup.com')) && (
                    <Menu.Item
                      name="Employee HC Hours Update"
                      disabled={commonStore.filterModeZero.includes('HAR01')}
                      onClick={() => routeChange('/NFAIManualHoursAdd')}
                      style={{ color: '#616161' }}
                    >
                      Employee HC Hours Update
                    </Menu.Item>
                )}
                {(user?.customerName === 'NFAIReport' && user?.email === 'mohamedsabir.k@pcplgroup.com') && (
                      <Menu.Item
                        name="Employee HC Hours Update"
                        disabled={commonStore.filterModeZero.includes('HAR01')}
                        onClick={() => routeChange('/NFAIMonthlyManualHoursAdd')}
                        style={{ color: '#616161' }}
                      > Employee HC Monthly Hours Update </Menu.Item>                
                )}
                {(user?.customerName === 'EFX-RES' ||
                    user?.customerName === 'Restoration')  &&
                    (commonStore.filterModeOne.includes('TWMPR01')) && (
                    <Menu.Item
                      name="Restoration Productivity Report"
                      disabled={commonStore.filterModeZero.includes('TWMPR01')}
                      onClick={() =>
                        routeChange('/RestorationProductivityReport')
                      }
                      style={{ color: '#616161' }}
                    >
                      Title Wise Monthly Productivity 
                    </Menu.Item>
                  )}

                  {(user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization') ? (
                    <Menu.Item
                    name="Monthly Productivity Report"
                    disabled={commonStore.filterModeZero.includes('MPR01')}
                    onClick={()=>
                      routeChange('/MonthlyProductivityReport')
                    }
                    style={{color:"#616161"}}
                    >
                    Monthly Productivity Report
                    </Menu.Item>
                  ):null}
                  {(user?.customerName==="Restoration"  || user?.customerName === 'NFAIReport' ) && (
                    <Menu.Item
                    name="Honey CombStatus Report"
                    disabled={commonStore.filterModeZero.includes('HAR01')}
                    onClick={()=>
                      routeChange('/HoneyCombStatusReport')
                    }
                    style={{color:"#616161"}}
                    >
                    Honey CombStatus Report
                    </Menu.Item>
                  )}
                  {(user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization') ? (
                    <Menu.Item
                    name="Operational Report"
                    disabled={commonStore.filterModeZero.includes('OSR01')}
                    onClick={()=>
                      routeChange('/OperationalReport')
                    }
                    style={{color:"#616161"}}
                    >
                    Operational Report Summary
                    </Menu.Item>
                  ):null}
                  {(user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization') ? (
                    <Menu.Item
                    name="Cluster Wise Operational Report"
                    disabled={commonStore.filterModeZero.includes('CWOR01')}
                    onClick={()=>
                      routeChange('/ClusterWiseOperationalReport')
                    }
                    style={{color:"#616161"}}
                    >
                    Operational Report By Cluster
                    </Menu.Item>
                  ):null}
                {(user?.customerName === 'Restoration') ? (
                   <Menu.Item
                  name="Create New Title Inventory"
                  // disabled={commonStore.filterModeZero.includes('CWOR01')}
                  onClick={()=>
                  routeChange('/CreateNewTitleInventory')
                 }
                  style={{color:"#616161"}}
                >
                Title Inventory
                </Menu.Item>
                ):null}
               {(user?.customerName === 'Restoration' && user?.departmentName === 'Colorization') ? (
                   <Menu.Item
                  name="Production Title Deactivation"
                  onClick={()=>
                  routeChange('/ProductionTitleDeactivation')
                 }
                  style={{color:"#616161"}}
                >
                 Production Title Deactivation
                </Menu.Item>
                ):null}
              {(user?.customerName === 'Restoration' && user?.departmentName !== 'Colorization') ? (
                                <Menu.Item
                                name="Restoration Client Correction"
                                disabled={commonStore.filterModeZero.includes('CWOR01')}
                                onClick={()=>
                                routeChange('/ClientCorrection')
                              }
                                style={{color:"#616161"}}
                              >
                              Restoration Client Correction
                              </Menu.Item>
                              ):null}
                  {commonStore.filterModeTwo?.includes('RSMAHCR') ? (
                    <></>
                  ) : (
                    user?.customerName === 'CG' && (
                      <Menu.Item
                        disabled={commonStore.filterModeZero.includes(
                          'RSMAHCR',
                        )}
                        name="Man Days Hours Calculate Report"
                        onClick={() => routeChange('/manDaysReport')}
                        style={{ color: '#616161' }}
                        //Man Days Hours Calculate Report
                      >
                        {' '}
                        Man Days Hours Calculate Report
                      </Menu.Item>
                    )
                  )}
                </span>
              )}
              {(user?.customerName === 'PC Technology' ||
                user?.customerName === 'Paramount Global') && (
                <Menu.Item
                  name="Asset Tracking Report"
                  // disabled={ dashboardStore.dashboard.selectedUserRoleId.includes("RMDB01") ? false : true }       demo some role create
                  onClick={() => routeChange('/assetReport')}
                  style={{ color: '#616161' }}
                  //Restoration Qc Summary
                >
                  {' '}
                  Asset Tracking Report
                </Menu.Item>
              )}
              {user?.customerName === 'LVPCMS' && (
                <Menu.Item
                  name="Pivot Table"
                  disabled={
                    dashboardStore.dashboard.selectedUserRoleId.includes(
                      'RPTB01',
                    )
                      ? false
                      : true
                  }
                  onClick={() => routeChange('/filmfestivalreport')}
                  style={{ color: '#616161' }}
                  //Film Festival Report
                  //
                >
                  {' '}
                  {
                    (userLanguage[0].Sidebar?.M10I03 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
                {user?.customerName === 'PCPLCRM'  && (
                <Menu.Item
                  name="IT Asset List"
                  disabled={
                    dashboardStore.dashboard.selectedUserRoleId.includes(
                      'ITAT01',
                    )
                      ? false
                      : true
                  }
                  onClick={() => routeChange('/IT_Asset_List')}
                  style={{ color: '#616161' }}
                 // IT Asset List
                >
                  IT Asset List
                </Menu.Item>
              )}
            </Menu.Menu>{' '}
            
          </Menu.Item>

          {(
            user?.customerName === 'NFAIReport' ||
            user?.customerName === 'EFX-RES' ||
            user?.customerName === 'Restoration') && (
            <Menu.Item name="ADL">
              {' '}
              <Icon
                name="list" //ADL Report
              />
              {
                (userLanguage[0].Sidebar?.M15 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              {
                <Menu.Menu>
                  <Menu.Item
                    name="Assign Report Head"
                    onClick={() => routeChange('/AssignReportingHeadHierarchy')}
                    style={{ color: '#616161' }}
                    //Assign Report Head
                  >
                    {' '}
                    Assign Report Head
                  </Menu.Item>

                  <Menu.Item
                    name="ShiftMaster"
                    onClick={() => routeChange('/ShiftMaster')}
                    style={{ color: '#616161' }}
                    //Shift Master
                  >
                    {' '}
                    Shift Master
                  </Menu.Item>

                  <Menu.Item
                    name="ShiftRoster"
                    onClick={() => routeChange('/ShiftRoster')}
                    style={{ color: '#616161' }}
                    //Shift Roster
                  >
                    {' '}
                    Shift Roster
                  </Menu.Item>

                  <Menu.Item
                    name="ShiftModify"
                    onClick={() => routeChange('/ShiftModify')}
                    style={{ color: '#616161' }}
                    //Shift Master
                  >
                    {' '}
                    Shift Modify
                  </Menu.Item>

                  <Menu.Item
                    name="ADLUnlock"
                    onClick={() => routeChange('/ADLUnlock')}
                    style={{ color: '#616161' }}
                    //Unlock Employee
                  >
                    {' '}
                    ADL Unlock
                  </Menu.Item>
                </Menu.Menu>
              }
            </Menu.Item>
          )}

          {/* Pivot */}
          {PivotStore.saveAsPivotDataAll.length > 0 && (
            <Menu.Item name="Dynamic Report">
              <Icon
                name="file alternate outline"
                //Dynamic Report
              />
              {
                (userLanguage[0].Sidebar?.M11 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
              <Menu.Menu>
                {PivotStore.saveAsPivotDataAll.map((element: pivotData) => {
                  return (
                    <Menu.Item
                      name={element.tableName}
                      key={element.id}
                      // disabled={ dashboardStore.dashboard.selectedUserRoleId.includes("RPTB01") ? false : true }
                      onClick={() => {
                        if (hoverEnable) {
                          routeChange(`/pivotsaveasreport/${element.id}`);
                        }
                      }}
                      style={{ color: '#616161' }}
                    >
                      {element.tableName}
                      <Icon
                        name="pin"
                        className={pinColorFunc(element.id)}
                        onMouseEnter={() => setHoverEnable(false)}
                        onMouseLeave={() => setHoverEnable(true)}
                        onClick={() =>
                          PivotStore.pinnedIds(user?.id!, element.id)
                        }
                      />
                    </Menu.Item>
                  );
                })}
              </Menu.Menu>
            </Menu.Item>
          )}
         
          {/* Pivot */}
          <Menu.Item>
            <Icon
              name="user"
              //User
            />
            {
              (userLanguage[0].Sidebar?.M12 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            <Menu.Menu>
              {commonStore.filterModeTwo?.includes('SRPPB08') ? (
                <></>
              ) : (
                <Menu.Item
                  onClick={() => routeChange('/userlist')}
                  disabled={commonStore.filterModeZero?.includes('SRPPB08')}
                  style={{ color: '#616161' }}
                  //View User
                >
                  {
                    (userLanguage[0].Sidebar?.M12I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {commonStore.filterModeTwo?.includes('UCUB01') ? (
                <></>
              ) : (
                <Menu.Item
                  disabled={commonStore.filterModeZero?.includes('UCUB01')}
                  onClick={() =>
                    modalStore.openModal(
                      <>
                        {' '}
                        <RegisterForm />{' '}
                      </>,
                    )
                  }
                  style={{ color: '#616161' }}
                  //Create User
                >
                  {
                    (userLanguage[0].Sidebar?.M12I02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
            </Menu.Menu>
          </Menu.Item>
          <Menu.Item>
            <Icon
              name="setting"
              //Settings
            />
            {
              (userLanguage[0].Sidebar?.M13 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            <Menu.Menu>
              {commonStore.filterModeTwo?.includes('DYDB') ? (
                <></>
              ) : (
                <Menu.Item
                  disabled={commonStore.filterModeZero?.includes('DYDB')}
                  onClick={() => routeChange('/dashboard_configuration')}
                  style={{ color: '#616161' }}
                  //DashboardConfiguation
                >
                  {
                    (userLanguage[0].Sidebar?.M17 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}

              {user?.isAdmin ? (
                <Menu.Item
                  name="Roles and Permissions"
                  onClick={() => routeChange('/roles')}
                  style={{ color: '#616161' }}
                  //Roles and Permissions
                >
                  {
                    (userLanguage[0].Sidebar?.M13I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              ) : commonStore.filterModeTwo?.includes('SRB01') ? (
                <></>
              ) : (
                <Menu.Item
                  name="Roles and Permissions"
                  onClick={() => routeChange('/roles')}
                  disabled={commonStore.filterModeZero?.includes('SRB01')}
                  style={{ color: '#616161' }}
                  //Roles and Permissions
                >
                  {
                    (userLanguage[0].Sidebar?.M13I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {commonStore.filterModeTwo?.includes('SWLB01') ? (
                <></>
              ) : (
                <Menu.Item
                  disabled={commonStore.filterModeZero?.includes('SWLB01')}
                  onClick={() => routeChange('/workflowsettings')}
                  style={{ color: '#616161' }}
                  //Workflow
                >
                  {
                    (userLanguage[0].Sidebar?.M13I02 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {commonStore.filterModeTwo?.includes('SWMB01') ? (
                <></>
              ) : (
                <Menu.Item
                  disabled={commonStore.filterModeZero?.includes('SWMB01')}
                  onClick={() => routeChange('/metadataconfiguration')}
                  style={{ color: '#616161' }}
                  //MetaData Configuration
                >
                  {
                    (userLanguage[0].Sidebar?.M13I03 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
              {/* <Menu.Item
              // disabled={dashboardStore.dashboard.selectedUserRoleId.includes('SWLB01') ? false : true}
              onClick={() => routeChange("/generatelabel")}
              style={{ color: "#616161" }}
            >
              Generate Label
            </Menu.Item> */}
            </Menu.Menu>
          </Menu.Item>
        </Menu>
      </div>

      <div className="small-screen-sidebar">
        <Menu
          vertical
          fluid
          size="large"
          style={{ marginTop: '4.6em', bottom: '0', height: '100vh' }}
        >
          {/* {dashboardStore.dashboard.selectedUserRoleId.includes("MRAU01")?(
        <Menu>
          <Menu.Item
              onClick={() => routeChange("/assignuser")}
              style={{ color: "#616161" }}
            >
              Assign User
            </Menu.Item>
        </Menu>
      ):dashboardStore.dashboard.selectedUserRoleId.includes("DB02")?(
<Menu.Item
          exact
          disabled={
            dashboardStore.dashboard.selectedUserRoleId.includes("DB02")
              ? false
              : true
          }
          onClick={() => routeChange("/mediaAssets")}
        >
          <Icon name="home" />
          Home
        </Menu.Item>
      ):null} */}
          <Menu.Item
            exact="true"
            disabled={
              dashboardStore.dashboard.selectedUserRoleId.includes('DB02')
                ? false
                : true
            }
            onClick={() => routeChange('/mediaAssets')}
          >
            <Icon
              name="home"
              //Home
            />
            {
              (userLanguage[0].Sidebar?.M01 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Menu.Item>
          {commonStore.filterModeTwo?.includes(
            'a69e4760-5da1-4009-9098-e20fda89e7d8',
          ) ? (
            <></>
          ) : (
            <Menu.Item
              disabled={commonStore.filterModeZero?.includes(
                'a69e4760-5da1-4009-9098-e20fda89e7d8',
              )}
              onClick={() => routeChange('/dynamic_dashboard')}
              // dynamic_dashboard
            >
              Dynamic Dashboard
            </Menu.Item>
          )}

          <Menu.Item name="Assets">
            <Icon
              name="film"
              //Assets
            />
            {
              (userLanguage[0].Sidebar?.M08 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            <Menu.Menu>
              <Menu.Item
                name="Work Level Master"
                disabled={
                  dashboardStore.dashboard.selectedUserRoleId.includes('AWLB01')
                    ? false
                    : true
                }
                onClick={() => routeChange('/registerWorkLevelMaster')}
                style={{ color: '#616161' }}
                //Register Item Group
              >
                {
                  (userLanguage[0].Sidebar?.M08I01 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
              <Menu.Item
                name="View Work Level Master"
                disabled={
                  dashboardStore.dashboard.selectedUserRoleId.includes('AVIB01')
                    ? false
                    : true
                }
                onClick={() => routeChange('/viewWorkLevelMaster')}
                style={{ color: '#616161' }}
                //View Item Group
              >
                {
                  (userLanguage[0].Sidebar?.M08I02 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
              <Menu.Item
                name="View Assets"
                disabled={
                  dashboardStore.dashboard.selectedUserRoleId.includes('AILB01')
                    ? false
                    : true
                }
                onClick={() => routeChange('/mediaAssets')}
                style={{ color: '#616161' }}
                // View Item Level
              >
                {
                  (userLanguage[0].Sidebar?.M08I03 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>

              {commonStore.filterModeTwo?.includes('MRAU01') ? (
                <></>
              ) : (
                <Menu.Item
                  disabled={commonStore.filterModeZero?.includes('MRAU01')}
                  onClick={() => routeChange('/assignuser')}
                  style={{ color: '#616161' }}
                  //Assign User
                >
                  {
                    (userLanguage[0].Sidebar?.M08I04 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              )}
            </Menu.Menu>
          </Menu.Item>

          <Menu.Item name="Reports">
            <Icon
              name="user"
              //User
            />
            {
              (userLanguage[0].Sidebar?.M12 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            <Menu.Menu>
              <Menu.Item
                onClick={() => routeChange('/userlist')}
                disabled={
                  dashboardStore.dashboard.selectedUserRoleId.includes(
                    'SRPPB08',
                  )
                    ? false
                    : true
                }
                style={{ color: '#616161' }}
                //View User  Meta Data
              >
                {
                  (userLanguage[0].Sidebar?.M12I01 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
              <Menu.Item
                disabled={
                  dashboardStore.dashboard.selectedUserRoleId.includes('UCUB01')
                    ? false
                    : true
                }
                onClick={() =>
                  modalStore.openModal(
                    <>
                      <RegisterForm />
                    </>,
                  )
                }
                style={{ color: '#616161' }}
                //Create User
              >
                {
                  (userLanguage[0].Sidebar?.M12I02 as any)?.[
                    `${commonStore.language.key}`
                  ]
                }
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>

          <Menu.Item name="Reports">
            <Icon
              name="list"
              //Reports
            />
            {
              (userLanguage[0].Sidebar?.M10 as any)?.[
                `${commonStore.language.key}`
              ]
            }

            {commonStore.filterModeTwo?.includes('RMDB01') ? (
              <></>
            ) : (
              <Menu.Menu>
                <Menu.Item
                  name="Reports Table"
                  disabled={commonStore.filterModeZero?.includes('RMDB01')}
                  onClick={() => routeChange('/reports')}
                  style={{ color: '#616161' }}
                  //Meta Data Report
                >
                  {
                    (userLanguage[0].Sidebar?.M10I01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </Menu.Item>
              </Menu.Menu>
            )}
          </Menu.Item>
        </Menu>
      </div>
    </Sidebar>
  );
});
